import React from 'react';
import { connect } from 'react-redux';

import WaitingAreaWebsiteButtonPage from './WaitingAreaWebsiteButtonPage.js';
import SmsNotificationCreateUpdatePage from './SmsNotificationCreateUpdatePage.js';
import WelcomeWaitingAreaPage from './WelcomeWaitingAreaPage.js';
import WaitingAreaCallerEntryPointPage from './WaitingAreaCallerEntryPointPage.js';
import WaitingAreaGeneralDetailPage from './WaitingAreaFormPage.js';
import WaitingAreaOperatingHoursPage from './WaitingAreaOperatingHoursPage.js';
import WaitingAreaLocalAccessHoursPage from './WaitingAreaLocalAccessHoursPage.js';
import WaitingAreaBeforeCallsPage from './WaitingAreaBeforeCallsPage.js';
import WaitingAreaBeforeCallsImportantInfoPage from './WaitingAreaBeforeCallsImportantInfoPage.js';
import WaitingAreaAfterCallsPage from './WaitingAreaAfterCallsPage.js';
import WaitingAreaLogoPauseImage from './WaitingAreaLogoPauseImage.js';
import WaitingAreaDeleteWAModal from '../components/pages/waiting-area/delete-wa/content.js';
import SuspendWAPage from '../components/pages/waiting-area/suspend/content.js';
import WaitingAreaDuringCallsPage from './WaitingAreaDuringCallsPage';
import SupportContactModal from './SupportContactModal';
import InfoForCallersModal from './WaitingAreaInfoForCallersModal';
import WAURLShareByEmailContainer from './WAURLShareByEmailContainer';
import WAURLShareByTextContainer from './WAURLShareByTextContainer';
import WAShareLinkMessageModalContainer from '../components/pages/waiting-area/share-link-message/content.js';
import ConsultNowSettingPage from './ConsultNowSettingPage.js';
import WAAudioSettingPage from './WAAudioSettingPage.js';
import SendConsultNowInvitationContent from '../components/pages/waiting-area/send-consult-now-invitation/content.js';
import CancelCNInvitationModal from '../components/pages/waiting-area/cancel-consult-now-invitation/content.js';
import ExtendCNInvitationModal from '../components/pages/waiting-area/extend-consult-now-invitation/content.js';
import objectAssign from 'object-assign';
import GroupConsultationSettingsPage from './GroupConsultationSettingsPage';

export const WaitingAreasViewOneModals = (props) => {
  let modals = '';
  let modalsForServiceProvider = '';
  let extendTimeModal = '';
  if (props.waitingArea && props.waitingArea.permissions && props.waitingArea.permissions.length > 0) {
    let hasEditWaitingAreaAccess = props.waitingArea.permissions.indexOf('EDIT') > -1;
    let hasViewWaitingAreaAccess = props.waitingArea.permissions.indexOf('VIEW') > -1;
    let hasAnswerCallAccess = props.waitingArea.permissions.indexOf('ANSWER_CALL') > -1;
    let hasOrgEditAccess = props.waitingArea.permissions.indexOf('ORGANISATION_EDIT') > -1;
    let hasExtendTimeAccess =
      props.waitingArea.permissions.indexOf('ANSWER_CALL') > -1 ||
      props.waitingArea.permissions.indexOf('MANAGE_ACCESS') > -1 ||
      props.waitingArea.permissions.indexOf('EDIT') > -1;

    if (hasEditWaitingAreaAccess && hasViewWaitingAreaAccess) {
      modals = (
        <div>
          <WaitingAreaWebsiteButtonPage />
          {props.showWAShareLinkMessageModal == true ? (
            <WAShareLinkMessageModalContainer waitingArea={props.waitingArea} updateOrView="update" />
          ) : (
            ''
          )}
          {props.showBeforeCallsModal == true ? (
            <WaitingAreaBeforeCallsPage waitingArea={props.waitingArea} updateOrView="update" />
          ) : (
            ''
          )}

          {props.showBeforeCallsImportantInfoModal == true ? (
            <WaitingAreaBeforeCallsImportantInfoPage waitingArea={props.waitingArea} updateOrView="update" />
          ) : (
            ''
          )}

          {props.showAfterCallsModal == true ? (
            <WaitingAreaAfterCallsPage waitingArea={props.waitingArea} updateOrView="update" />
          ) : (
            ''
          )}
          {props.showConsultNowSettingModal == true ? (
            <ConsultNowSettingPage
              waitingArea={props.waitingArea}
              isConsultNowEnabled={props.isConsultNowEnabled}
              updateOrView="update"
            />
          ) : (
            ''
          )}
          {props.showWAAudioSettingModal == true ? (
            <WAAudioSettingPage
              waitingArea={props.waitingArea}
              isRecordingEnabled={props.WARecordingFeature}
              updateOrView="update"
            />
          ) : (
            ''
          )}
          {props.showWaitingAreaWelcomeModal == true ? (
            <WelcomeWaitingAreaPage
              waitingArea={props.waitingArea}
              showWaitingAreaWelcomeModal={props.showWaitingAreaWelcomeModal}
            />
          ) : (
            ''
          )}

          {props.showCallerEntryModal == true ? (
            <WaitingAreaCallerEntryPointPage waitingArea={props.waitingArea} updateOrView="update" />
          ) : (
            ''
          )}
          {props.showDuringCallsModal == true ? (
            <WaitingAreaDuringCallsPage waitingArea={props.waitingArea} updateOrView="update" />
          ) : (
            ''
          )}
          {props.showInfoForCallersModal == true ? (
            <InfoForCallersModal waitingArea={props.waitingArea} updateOrView="update" />
          ) : (
            ''
          )}
          {props.showSupportContactModal == true ? (
            <SupportContactModal waitingArea={props.waitingArea} updateOrView="update" />
          ) : (
            ''
          )}
          {props.showDeleteWAModal == true ? (
            props.waitingArea.rooms && props.waitingArea.rooms.length > 0 ? (
              <WaitingAreaDeleteWAModal waitingArea={props.waitingArea} canDelete={false} dispatch={props.dispatch} />
            ) : (
              <WaitingAreaDeleteWAModal waitingArea={props.waitingArea} canDelete={true} dispatch={props.dispatch} />
            )
          ) : (
            ''
          )}
          <WaitingAreaGeneralDetailPage
            waitingAreaForm={props.waitingAreaForm}
            waitingArea={props.waitingArea}
            updateOrInsert="update"
          />
          <WaitingAreaOperatingHoursPage
            waitingAreaForm={props.waitingAreaForm}
            waitingArea={props.waitingArea}
            updateOrView="update"
          />
          <WaitingAreaLocalAccessHoursPage waitingArea={props.waitingArea} updateOrView="update" />
          <SmsNotificationCreateUpdatePage updateOrInsert="update" />
          <SmsNotificationCreateUpdatePage updateOrInsert="insert" />
          <SuspendWAPage waitingArea={props.waitingArea} />
          <WaitingAreaLogoPauseImage waitingArea={props.waitingArea} readOnly={false} />
          {props.showShareByEmailModal === true ? (
            <WAURLShareByEmailContainer waitingArea={props.waitingArea} dispatch={props.dispatch} />
          ) : (
            ''
          )}
          {props.showShareByTextModal === true ? (
            <WAURLShareByTextContainer waitingArea={props.waitingArea} dispatch={props.dispatch} />
          ) : (
            ''
          )}
          {props.showGCSettingsModal == true ? (
            <GroupConsultationSettingsPage
              waitingArea={props.waitingArea}
              isGCSettingsEnabled={true}
              updateOrView="update"
              dispatch={props.dispatch}
            />
          ) : (
            ''
          )}
        </div>
      );
    } else if (hasViewWaitingAreaAccess) {
      modals = (
        <div>
          <WaitingAreaWebsiteButtonPage />
          {props.showWAShareLinkMessageModal == true ? (
            <WAShareLinkMessageModalContainer waitingArea={props.waitingArea} updateOrView="view" />
          ) : (
            ''
          )}
          {props.showBeforeCallsModal == true ? (
            <WaitingAreaBeforeCallsPage waitingArea={props.waitingArea} updateOrView="view" />
          ) : (
            ''
          )}
          {props.showBeforeCallsImportantInfoModal == true ? (
            <WaitingAreaBeforeCallsImportantInfoPage waitingArea={props.waitingArea} updateOrView="view" />
          ) : (
            ''
          )}
          {props.showAfterCallsModal == true ? (
            <WaitingAreaAfterCallsPage waitingArea={props.waitingArea} updateOrView="view" />
          ) : (
            ''
          )}
          {props.showCallerEntryModal == true ? (
            <WaitingAreaCallerEntryPointPage waitingArea={props.waitingArea} updateOrView="view" />
          ) : (
            ''
          )}
          {props.showDuringCallsModal == true ? (
            <WaitingAreaDuringCallsPage waitingArea={props.waitingArea} updateOrView="view" />
          ) : (
            ''
          )}
          {props.showSupportContactModal == true ? (
            <SupportContactModal waitingArea={props.waitingArea} updateOrView="view" />
          ) : (
            ''
          )}
          {props.showInfoForCallersModal == true ? (
            <InfoForCallersModal waitingArea={props.waitingArea} updateOrView="view" />
          ) : (
            ''
          )}
          <WaitingAreaGeneralDetailPage waitingArea={props.waitingArea} updateOrInsert="view" />
          <WaitingAreaOperatingHoursPage waitingArea={props.waitingArea} updateOrView="view" />
          <WaitingAreaLocalAccessHoursPage waitingArea={props.waitingArea} updateOrView="view" />
          <SmsNotificationCreateUpdatePage updateOrInsert="update" />
          <SmsNotificationCreateUpdatePage updateOrInsert="insert" />
          <SuspendWAPage waitingArea={props.waitingArea} />
          <WaitingAreaLogoPauseImage waitingArea={props.waitingArea} readOnly={true} />
          {props.showShareByEmailModal === true ? (
            <WAURLShareByEmailContainer waitingArea={props.waitingArea} dispatch={props.dispatch} />
          ) : (
            ''
          )}
          {props.showShareByTextModal === true ? (
            <WAURLShareByTextContainer waitingArea={props.waitingArea} dispatch={props.dispatch} />
          ) : (
            ''
          )}
          {props.showConsultNowSettingModal == true ? (
            <ConsultNowSettingPage
              waitingArea={props.waitingArea}
              isConsultNowEnabled={props.isConsultNowEnabled}
              updateOrView="view"
            />
          ) : (
            ''
          )}
          {props.showWAAudioSettingModal == true ? (
            <WAAudioSettingPage
              waitingArea={props.waitingArea}
              isRecordingEnabled={props.WARecordingFeature}
              updateOrView="view"
            />
          ) : (
            ''
          )}
          {props.showGCSettingsModal == true ? (
            <GroupConsultationSettingsPage
              waitingArea={props.waitingArea}
              isGCSettingsEnabled={true}
              updateOrView="view"
              dispatch={props.dispatch}
            />
          ) : (
            ''
          )}
        </div>
      );
    }
    if (hasAnswerCallAccess) {
      modalsForServiceProvider = (
        <div>
          {props.showCancelCNInvitationModal === true ? (
            <CancelCNInvitationModal waitingArea={props.waitingArea} dispatch={props.dispatch} />
          ) : (
            ''
          )}
          {props.showConsultNowInvitationModal === true ? (
            <SendConsultNowInvitationContent
              waitingArea={props.waitingArea}
              isCurrentUserInCall={props.isCurrentUserInCall}
              consultNowInitiatedRoomsFiltered={props.consultNowInitiatedRoomsFiltered}
              consultNowRoomsFiltered={props.consultNowRoomsFiltered}
              dispatch={props.dispatch}
            />
          ) : (
            ''
          )}
        </div>
      );
    }
    if (hasExtendTimeAccess) {
      extendTimeModal = (
        <div>
          {props.showExtendCNInvitationModal === true ? (
            <ExtendCNInvitationModal waitingArea={props.waitingArea} dispatch={props.dispatch} />
          ) : (
            ''
          )}
        </div>
      );
    }
  }
  return (
    <>
      {modals}
      {modalsForServiceProvider}
      {extendTimeModal}
    </>
  );
};

function mapStateToProps(state) {
  let selectedWaitingArea = state.waitingAreaReducer.cleanWaitingArea;

  if (!!state.waitingAreaReducer.selectedWaitingAreaId)
    selectedWaitingArea = state.waitingAreaReducer.waitingAreas.find(
      (wa) => wa.id === state.waitingAreaReducer.selectedWaitingAreaId
    );

  const waitingArea = objectAssign({}, state.waitingAreaReducer.cleanWaitingArea, selectedWaitingArea);
  return {
    waitingAreaForm: state.waitingAreaReducer.waitingAreaForm,
    isConsultNowEnabled: waitingArea.isConsultNowEnabled,
    isCurrentUserInCall: state.usersReducer.isInCall,
    showWAShareLinkMessageModal: state.modalReducer.showWAShareLinkMessageModal,
    showBeforeCallsModal: state.modalReducer.showBeforeCallsModal,
    showBeforeCallsImportantInfoModal: state.modalReducer.showBeforeCallsImportantInfoModal,
    showCallerEntryModal: state.modalReducer.showCallerEntryModal,
    showDuringCallsModal: state.modalReducer.showDuringCallsModal,
    showAfterCallsModal: state.modalReducer.showAfterCallsModal,
    showConsultNowSettingModal: state.modalReducer.showConsultNowSettingModal,
    showWaitingAreaWelcomeModal: state.modalReducer.showWaitingAreaWelcomeModal,
    showSupportContactModal: state.modalReducer.showSupportContactModal,
    showInfoForCallersModal: state.modalReducer.showInfoForCallersModal,
    showDeleteWAModal: state.modalReducer.showDeleteWAModal,
    showShareByEmailModal: state.modalReducer.showShareByEmailModal,
    showShareByTextModal: state.modalReducer.showShareByTextModal,
    showConsultNowInvitationModal: state.modalReducer.showConsultNowInvitationModal,
    showCancelCNInvitationModal: state.modalReducer.showCancelCNInvitationModal,
    showExtendCNInvitationModal: state.modalReducer.showExtendCNInvitationModal,
    showWAAudioSettingModal: state.modalReducer.showWAAudioSettingModal,
    WARecordingFeature: state.waitingAreaReducer.WARecordingFeature,
    showGCSettingsModal: state.modalReducer.showGCSettingsModal,
  };
}
export default connect(mapStateToProps, null)(WaitingAreasViewOneModals);
